import { render } from "./formations.vue?vue&type=template&id=51cb78dd"
import script from "./formations.vue?vue&type=script&lang=js"
export * from "./formations.vue?vue&type=script&lang=js"

import "./formations.vue?vue&type=style&index=0&id=51cb78dd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__